/* eslint-disable no-unused-vars */
/* eslint-disable eqeqeq */
/* eslint-disable @scandipwa/scandipwa-guidelines/use-namespace */
/* eslint-disable fp/no-let */
/* eslint-disable max-len */
/* eslint-disable no-console */
/* eslint-disable max-lines */
/**
 * ScandiPWA - Progressive Web App for Magento
 *
 * Copyright © Scandiweb, Inc. All rights reserved.
 * See LICENSE for license details.
 *
 * @license OSL-3.0 (Open Software License ("OSL") v. 3.0)
 * @package scandipwa/base-theme
 * @link https://github.com/scandipwa/base-theme
 */
import { get, isEmpty, map } from 'lodash';

import CartQuery from 'Query/Cart.query';
import { updatePopupProducts } from 'Store/AddToCartPopUp';
import { updateTotals } from 'Store/Cart/Cart.action';
import { showNotification } from 'Store/Notification/Notification.action';
import { isSignedIn } from 'Util/Auth';
import { getGuestQuoteId, setGuestQuoteId } from 'Util/Cart';
import history from 'Util/History';
import {
    roundPrice
} from 'Util/Price';
import {
    getExtensionAttributes,
    GIFT_CARD
} from 'Util/Product';
import { fetchMutation, fetchQuery, getErrorMessage } from 'Util/Request';

import ProductListQuery from '../../query/ProductList.query';

export const LinkedProductsDispatcher = import(
    /* webpackMode: "lazy", webpackChunkName: "dispatchers" */
    'Store/LinkedProducts/LinkedProducts.dispatcher'
);

/**
 * Product Cart Dispatcher
 * @class CartDispatcher
 * @namespace Pwa/Store/Cart/Dispatcher/CartDispatcher */
export class CartDispatcher {
    updateInitialCartData(dispatch) {
        const amazonPaySessionId = localStorage.getItem('amazonPaySessionId');
        let isProgressCheckout = localStorage.getItem('isProgressCheckout');
        const changePayment = localStorage.getItem('changepayment', '0');

        if (!(window.location.href.includes('/cart') || window.location.href.includes('/checkout') || window.location.href.includes('/success') || window.location.href.includes('/onepage/'))) {
            localStorage.setItem('isProgressCheckout', '');
            isProgressCheckout = '';
        }
        if ((!isEmpty(amazonPaySessionId) && !isEmpty(isProgressCheckout)) || changePayment == '1') {
            return;
        }

        if (!isEmpty(isProgressCheckout) && window.location.href.includes('stripepay/success')) {
            return;
        }

        const guestQuoteId = getGuestQuoteId();

        if (isSignedIn()) {
            // This is logged in customer, no need for quote id
            this._syncCartWithBE(dispatch);
        } else if (guestQuoteId) {
            // This is guest
            this._syncCartWithBE(dispatch, guestQuoteId);
        }
    }

    createGuestEmptyCart(dispatch) {
        return this._createEmptyCart(dispatch).then(
            /** @namespace Pwa/Store/Cart/Dispatcher/_createEmptyCart/then */
            (data) => {
                setGuestQuoteId(data);
                this._updateCartData({}, dispatch);
                return data;
            }
        );
    }

    resetGuestCart(dispatch) {
        return this._updateCartData({}, dispatch);
    }

    _createEmptyCart(dispatch) {
        return fetchMutation(CartQuery.getCreateEmptyCartMutation()).then(
            /** @namespace Pwa/Store/Cart/Dispatcher/fetchMutation/then */
            ({ createEmptyCart }) => createEmptyCart,
            /** @namespace Pwa/Store/Cart/Dispatcher/fetchMutation/then */
            (error) => dispatch(showNotification('error', error[0].message))
        );
    }

    handle_syncCartWithBESuccess(dispatch, { cartData }) {
        this._updateCartData(cartData, dispatch);
    }

    handle_syncCartWithBEError(dispatch, error) {
        return this._createEmptyCart(dispatch)
            .then(
                /** @namespace Pwa/Store/Cart/Dispatcher/_createEmptyCart/then */
                (data) => {
                    setGuestQuoteId(data);
                    this._updateCartData({}, dispatch);
                }
            );
    }

    _syncCartWithBE(dispatch) {
        // Need to get current cart from BE, update cart
        fetchQuery(CartQuery.getCartQuery(
            !isSignedIn() && getGuestQuoteId()
        )).then(
            /** @namespace Pwa/Store/Cart/Dispatcher/fetchQuery/then */
            (result) => {
                this.handle_syncCartWithBESuccess(dispatch, result);
            },
            /** @namespace Pwa/Store/Cart/Dispatcher/fetchQuery/then */
            (error) => this.handle_syncCartWithBEError(dispatch, error)
        );
    }

    changeItemQty(dispatch, options, tries = 0) {
        const { item_id, quantity, sku } = options;

        if (tries > 2) {
            dispatch(showNotification('error', __('Internal server error. Can not add to cart.')));
            return Promise.reject();
        }

        return fetchMutation(CartQuery.getSaveCartItemMutation(
            { sku, item_id, quantity },
            !isSignedIn() && getGuestQuoteId()
        )).then(
            /** @namespace Pwa/Store/Cart/Dispatcher/fetchMutation/then */
            ({ saveCartItem: { cartData } }) => this._updateCartData(cartData, dispatch),
            /** @namespace Pwa/Store/Cart/Dispatcher/fetchMutation/then */
            (error) => {
                const [{ debugMessage = '' }] = error || [{}];

                if (debugMessage.match('No such entity with cartId ')) {
                    return this._createEmptyCart(dispatch).then(
                        /** @namespace Pwa/Store/Cart/Dispatcher/_createEmptyCart/then */
                        (data) => {
                            setGuestQuoteId(data);
                            this._updateCartData({}, dispatch);
                            return this.changeItemQty(dispatch, options, tries + 1);
                        }
                    );
                }

                dispatch(showNotification('error', error[0].message));
                return Promise.reject();
            }
        );
    }

    async mergeCarts(sourceCartId, destinationCartId, dispatch) {
        try {
            const {
                mergeCarts: {
                    id = ''
                } = {}
            } = await fetchMutation(
                CartQuery.getMergeCartQuery(sourceCartId, destinationCartId)
            );

            return id;
        } catch (error) {
            dispatch(showNotification('error', getErrorMessage(error)));
            return null;
        }
    }

    async updateToGoogleAnalyticsData(options) {
        const { product, quantity } = options;
        if (!isEmpty(product && product.price_range && product.price_range.minimum_price && product.price_range.minimum_price.final_price)) {
            const {
                id,
                name,
                sku,
                price_range,
                attributes,
                type_id
            } = product;

            const pro_id = id;
            const { minimum_price } = price_range;
            const {
                final_price, default_final_price_excl_tax, regular_price, default_final_price
            } = minimum_price;
            // const { currency, value } = default_final_price_excl_tax;

            let finalPriceVal = final_price.value;
            if (type_id === 'bundle') {
                // finalPriceVal = default_final_price_excl_tax.value;
                finalPriceVal = default_final_price.value;
            }

            const pro_price = roundPrice(finalPriceVal);
            const { currencyCode, storeId } = window.storeConfig;

            // Brand
            let brand = '';
            if (attributes && attributes.brand) {
                const brandId = attributes.brand?.attribute_value ?? null;
                if (brandId) {
                    brand = attributes.brand.attribute_options[brandId].label ?? '';
                }
            }

            const selectedProductsArray = [];

            const matchedProduct = () => {
                const {
                    product: { items }
                } = options;

                let brand = '';
                if (attributes && attributes.brand) {
                    const brandId = attributes.brand?.attribute_value ?? null;
                    if (brandId) {
                        brand = attributes.brand.attribute_options[brandId].label ?? '';
                    }
                }

                const {
                    productOptionsData: { productOptions }
                } = options;

                productOptions.map((option) => {
                    const productmatched = items.find(({ option_id, required }) => option_id === option.id && required === false);

                    if (!productmatched) {
                        return null;
                    }

                    const selectedProduct = productmatched.options.find(({ id }) => id == option.value[0]);

                    const { product } = selectedProduct;

                    const {
                        name,
                        sku,
                        id,
                        price_range,
                        attributes,
                        type_id: selectedBundleProduct
                    } = product;

                    const pro_id = id;

                    const { minimum_price } = price_range;
                    const {
                        final_price, default_final_price_excl_tax, regular_priceregular_price, default_final_price
                    } = minimum_price;
                    let finalPriceVal = final_price.value;
                    if (selectedBundleProduct === 'bundle') {
                        // finalPriceVal = default_final_price_excl_tax.value;
                        finalPriceVal = default_final_price.value;
                    }
                    const pro_price = roundPrice(finalPriceVal);

                    return (
                        selectedProductsArray.push({
                            name,
                            id: sku,
                            sku,
                            product_id: `${pro_id}`,
                            price: `${pro_price}`,
                            quantity,
                            brand
                        })
                    );
                });
            };

            let products = [{
                name,
                id: sku,
                sku,
                product_id: `${pro_id}`,
                price: `${pro_price}`,
                quantity,
                brand
            }];

            if (type_id === 'bundle') {
                matchedProduct();
                products = [...selectedProductsArray, products[0]];
            }

            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({ ecommerce: null }); // Clear the previous ecommerce object.
            window.dataLayer.push({
                event: 'addToCart',
                ecommerce: {
                    currencyCode,
                    storeId,
                    pageType: 'productPage',
                    add: {
                        products
                    }
                }
            });
        }
    }

    async addProductToCart(dispatch, options) {
        const guestQuoteId = getGuestQuoteId();
        const {
            product,
            giftCardData,
            quantity,
            productOptionsData,
            noNeedPopup = false,
            optionsSelected = []
        } = options;

        this.updateToGoogleAnalyticsData(options);

        const {
            sku,
            type_id: product_type
        } = product;

        const {
            productOptions,
            productOptionsMulti
        } = productOptionsData || {};

        if (!guestQuoteId) {
            await this.createGuestEmptyCart(dispatch);
        }

        if (product_type === GIFT_CARD) {
            let giftCardOptions = {};

            let am_giftcard_amount_custom = {};

            const {
                your_name = '', recipient_name = '', recipient_email = '', gift_message = '', giftPrice, giftImage
            } = giftCardData;

            if (giftPrice.price_id) {
                const { value } = giftPrice.value;
                am_giftcard_amount_custom = value;
            } else {
                am_giftcard_amount_custom = giftPrice;
            }
            giftCardOptions = {
                am_giftcard_amount_custom,
                am_giftcard_sender_name: your_name,
                am_giftcard_recipient_name: recipient_name,
                am_giftcard_recipient_email: recipient_email,
                am_giftcard_message: gift_message,
                am_giftcard_image: giftImage.id
            };

            const data = {
                sku,
                product_type,
                quantity
            };
            const cart_items = [{
                data,
                gift_card_options: giftCardOptions
            }];
            const cart_id = getGuestQuoteId();
            const inputData = {
                cart_items,
                cart_id
            };

            if (this._canBeAdded(options)) {
                try {
                    const { addAmGiftCardProductsToCart: { cartData } } = await fetchMutation(CartQuery.getSavedAmGiftCardProductsToCart(
                        inputData, !isSignedIn() && getGuestQuoteId()
                    ));

                    return this._updateCartData(cartData, dispatch);
                } catch ([{ message }]) {
                    // dispatch(showNotification('error', message));
                    return Promise.reject();
                }

                // return fetchMutation(CartQuery.getSavedAmGiftCardProductsToCart(
                //     inputData, !isSignedIn() && this._getGuestQuoteId()
                // )).then(
                //     /** @namespace Pwa/Store/Cart/Dispatcher/fetchMutation/then */
                //     ({ addAmGiftCardProductsToCart: { cartData } }) => {
                //         // Trigger Upsell product popup.
                //         this._triggerPopUp({ sku, ...cartData }, dispatch);
                //         this._updateCartData(cartData, dispatch);
                //     },
                //     /** @namespace Pwa/Store/Cart/Dispatcher/fetchMutation/then */
                //     ([{ message }]) => {
                //         dispatch(showNotification('error', message));
                //         return Promise.reject();
                //     }
                // );
            }
        } else {
            const value = {
                extension_attributes: {
                    configurable_item_options: optionsSelected
                }
            };
            const productToAdd = {
                sku,
                // product_type,
                quantity,
                product_option: {
                    extension_attributes: getExtensionAttributes(
                        {
                            ...product,
                            productOptions,
                            productOptionsMulti
                        }
                    )
                }

            };

            if (this._canBeAdded(options)) {
                try {
                    if (sku === 'KSDR002CON' || sku === 'KRLBCUSTOM') {
                        const {
                            configurable_product_options_selection
                        } = product;

                        const {
                            variant
                        } = configurable_product_options_selection;

                        const cart_id = getGuestQuoteId();

                        await fetchMutation(CartQuery.addConfigurableProductsToCart(
                            // eslint-disable-next-line no-undef
                            cart_id, sku, quantity, variant.sku
                        )).then(
                            (res) => {
                                this._syncCartWithBE(dispatch);
                                dispatch(showNotification('success', __('Product added to cart!')));
                            },
                            (err) => {
                                dispatch(showNotification('error', err[0].message));
                            }
                        );
                    } else {
                        const response = await fetchMutation(CartQuery.getSaveCartItemMutation(
                            productToAdd, !isSignedIn() && getGuestQuoteId()
                        ));

                        const { saveCartItem: { cartData } } = response;
                        // Trigger Upsell product popup.
                        if (!noNeedPopup) {
                            this._triggerPopUp({ sku, ...cartData }, dispatch);
                        }

                        console.log(response);

                        return this._updateCartData(cartData, dispatch);
                    }
                } catch (data) {
                    const [{ message, debugMessage = '' }] = data;
                    if (debugMessage && debugMessage.includes('such entity with cart')) {
                        localStorage.setItem('shipping_method_code', '');
                        localStorage.setItem('shipping_carrier_code', '');
                        localStorage.setItem('shipping_amount', '');
                        localStorage.setItem('amazonPaySessionId', '');
                        localStorage.setItem('isProgressCheckout', '');
                        localStorage.setItem('stripeKey', '');
                        localStorage.setItem('changepayment', '');
                        localStorage.setItem('select_Payment', '');
                        return this.createGuestEmptyCart(dispatch);
                    }
                    dispatch(showNotification('error', message));

                    return Promise.reject();
                }
            }
        }

        return Promise.reject();
    }

    async addBundleProductToCart(dispatch, options) {
        let guestQuoteId = await getGuestQuoteId(); // Add await here

        const {
            product,
            quantity,
            selectedBundleOptions
        } = options;

        // this.updateToGoogleAnalyticsData(options);

        const {
            sku,
            type_id: product_type
        } = product;

        if (!guestQuoteId) {
            await this.createGuestEmptyCart(dispatch);
            guestQuoteId = await getGuestQuoteId(); // Retry after creating the cart
        }

        // If still no guestQuoteId, exit early
        if (!guestQuoteId) {
            dispatch(showNotification('error', 'Unable to get cart ID. Please try again.'));
            return;
        }

        try {
            const { addBundleProductsToCart } = await fetchMutation(
                CartQuery.addBundleProductsToCartMutation(
                    guestQuoteId, sku, quantity, selectedBundleOptions
                )
            );

            this._syncCartWithBE(dispatch);
            // eslint-disable-next-line consistent-return
            return addBundleProductsToCart; // ✅ Return result here
        } catch (err) {
            dispatch(showNotification('error', err[0]?.message || 'Add to cart failed.'));
            throw err; // Let the caller catch it
        }
    }

    _triggerPopUp(options, dispatch) {
        const { sku, items } = options;
        let productTypePopup = 'crosssell';

        const { location } = history;

        const { state } = location;

        if (!state || state === undefined) {
            productTypePopup = 'related';
        }
        const currentItem = items.filter((item) => item.sku.includes(sku));
        const productLinks = get(currentItem, '0.product.product_links', []);
        // const upsellProducts = productLinks.filter((link) => link.link_type === 'upsell');
        const upsellProducts = productLinks.filter((link) => link.link_type === `${productTypePopup}`);

        const productsSkuArray = map(upsellProducts, (product) => product.linked_product_sku);
        if (isEmpty(productsSkuArray)) {
            const data = {};
            dispatch(updatePopupProducts({ success: data, currentItem }));
            return;
        }

        const query = {
            sku: {
                in: productsSkuArray
            }
        };

        fetchQuery(ProductListQuery.getPopupQuery(query)).then(
            // eslint-disable-next-line @scandipwa/scandipwa-guidelines/use-namespace
            (success) => {
                dispatch(updatePopupProducts({ success, currentItem }));
            },
            (error) => console.log('error', error)
        );
    }

    // async updateToGaDataRemoveCart(item_id) {
    //     window.dataLayer = window.dataLayer || [];
    //     window.dataLayer.push({ ecommerce: null }); // Clear the previous ecommerce object.
    //     window.dataLayer.push({
    //         event: 'removeFromCart',
    //         ecommerce: {
    //             remove: {
    //                 products: [{
    //                     id: `${item_id}`
    //                 }]
    //             }
    //         }
    //     });
    // }

    removeProductFromCart(dispatch, item_id) {
        // this.updateToGaDataRemoveCart(item_id);

        return fetchMutation(CartQuery.getRemoveCartItemMutation(
            item_id,
            !isSignedIn() && getGuestQuoteId()
        )).then(
            /** @namespace Pwa/Store/Cart/Dispatcher/fetchMutation/then */
            ({ removeCartItem: { cartData } }) => {
                this._updateCartData(cartData, dispatch);
                return cartData;
            },
            /** @namespace Pwa/Store/Cart/Dispatcher/fetchMutation/then */
            (error) => {
                dispatch(showNotification('error', error[0].message));
                return null;
            }
        );
    }

    async updateToGaDataAddCoupon(couponCode) {
        const { storeId } = window.storeConfig;
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ ecommerce: null }); // Clear the previous ecommerce object.
        window.dataLayer.push({
            event: 'addCoupon',
            ecommerce: {
                storeId,
                pageType: 'checkoutPage',
                addCoupon: {
                    coupon: `${couponCode}`
                }
            }
        });
    }

    async updateToGaDataRemoveCoupon(couponCode) {
        const { storeId } = window.storeConfig;
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ ecommerce: null }); // Clear the previous ecommerce object.
        window.dataLayer.push({
            event: 'removeCoupon',
            ecommerce: {
                storeId,
                pageType: 'checkoutPage',
                removeCoupon: {
                    coupon: `${couponCode}`
                }
            }
        });
    }

    async applyCouponToCart(dispatch, couponCode) {
        this.updateToGaDataAddCoupon(couponCode);
        const guestQuoteId = getGuestQuoteId();

        if (!guestQuoteId) {
            await this.createGuestEmptyCart(dispatch);
        }

        try {
            const { applyCoupon: { cartData } } = await fetchMutation(CartQuery.getApplyCouponMutation(
                couponCode, !isSignedIn() && getGuestQuoteId()
            ));

            this._updateCartData(cartData, dispatch);
            dispatch(showNotification('success', __('Coupon was applied!')));
        } catch (error) {
            dispatch(showNotification('error', error[0].message));
        }
    }

    removeCouponFromCart(dispatch, couponCode) {
        this.updateToGaDataRemoveCoupon(couponCode);
        return fetchMutation(CartQuery.getRemoveCouponMutation(
            !isSignedIn() && getGuestQuoteId()
        )).then(
            /** @namespace Pwa/Store/Cart/Dispatcher/fetchMutation/then */
            ({ removeCoupon: { cartData } }) => {
                this._updateCartData(cartData, dispatch);
                dispatch(showNotification('success', __('Coupon was removed!')));
            },
            /** @namespace Pwa/Store/Cart/Dispatcher/fetchMutation/then */
            (error) => dispatch(showNotification('error', error[0].message))
        );
    }

    updateCrossSellProducts(items = [], dispatch) {
        if (items && items.length) {
            if (items.length === 0) {
                return;
            }
            const { product: { sku } } = items[0];
            const product_links = items.reduce((links, product) => {
                const { product: { product_links, variants = [] }, sku: variantSku } = product;

                const { product_links: childProductLinks } = variants.find(({ sku }) => sku === variantSku) || {};

                if (childProductLinks) {
                    Object.values(childProductLinks).filter(({ link_type }) => link_type === 'crosssell')
                        .map((item) => links.push(item));
                }

                if (product_links) {
                    Object.values(product_links).filter(({ link_type }) => link_type === 'crosssell')
                        .map((item) => links.push(item));
                }

                return links;
            }, []);

            if (product_links.length !== 0) {
                LinkedProductsDispatcher.then(
                    ({ default: dispatcher }) => dispatcher.fetchCrossSellProducts(dispatch, sku)
                );
            } else {
                LinkedProductsDispatcher.then(
                    ({ default: dispatcher }) => dispatcher.clearCrossSellProducts(dispatch)
                );
            }
        } else {
            LinkedProductsDispatcher.then(
                ({ default: dispatcher }) => dispatcher.clearCrossSellProducts(dispatch)
            );
        }
    }

    async addMultipleProducts(dispatch, products) {
        const guestCartId = getGuestQuoteId();

        const cart_items = [];
        products.map((item) => cart_items.push(
            {
                data: {
                    quantity: item.quantity || 1,
                    sku: item.sku
                }
            }
        ));

        await fetchMutation(CartQuery.addSimpleProductsToCart(
            guestCartId,
            cart_items
            // eslint-disable-next-line no-undef
        )).then(
            /** @namespace Pwa/Route/CmsPage/Component/fetchMutation/then */
            (res) => {
                this._syncCartWithBE(dispatch);
                dispatch(showNotification('success', __('Products added to cart!')));
                return res;
            },
            /** @namespace Pwa/Route/CmsPage/Component/fetchMutation/then */
            (err) => {
                dispatch(showNotification('error', err[0].message));
            }
        );
    }

    async addMultipleProductsToCart(dispatch, products) {
        let guestCartId = getGuestQuoteId();

        if (!guestCartId) {
            await this.createGuestEmptyCart(dispatch);
            guestCartId = getGuestQuoteId();
        }

        await fetchMutation(CartQuery.addMutipleSimpleProductsToCart(
            guestCartId,
            products
            // eslint-disable-next-line no-undef
        )).then(
            /** @namespace Pwa/Route/CmsPage/Component/fetchMutation/then */
            (res) => {
                this._syncCartWithBE(dispatch);
                dispatch(showNotification('success', __('Products added to cart!')));
                return res;
            },
            /** @namespace Pwa/Route/CmsPage/Component/fetchMutation/then */
            (err) => {
                dispatch(showNotification('error', err[0].message));
            }
        );
    }

    _updateCartData(cartData, dispatch) {
        dispatch(updateTotals(cartData));
    }

    /**
     * @param {*} attribute
     * @param {*} product
     */
    _getProductAttribute(attribute, product) {
        const { variants, configurableVariantIndex, [attribute]: attributeValue } = product;
        return configurableVariantIndex >= 0
            ? variants[configurableVariantIndex][attribute]
            : attributeValue;
    }

    /**
     * Check if it is allowed to add product to cart
     * @param {Object} options Cart options
     * @return {Boolean} Indicates is allowed or not
     * @memberof CartDispatcher
     */
    _canBeAdded(options) {
        if (options.product && options.quantity && (options.product.quantity + options.quantity) < 1) {
            return false;
        }

        if (options.quantity === 0) {
            return false;
        }

        return true;
    }
}

export default new CartDispatcher();
